<div id="paypal-button-container"></div>

<script>
  import { afterUpdate } from 'svelte';

  afterUpdate(() => {
    paypal.Buttons({
      style: {
          shape: 'rect',
          color: 'black',
          layout: 'vertical',
          label: 'subscribe'
      },
      createSubscription: function(data, actions) {
        // check /billing/plans for more info
        return actions.subscription.create({
          'plan_id': 'P-53K84918EP213610EL6XWC5Y'
        });
      },
      onApprove: function(data, actions) {
        alert(data.subscriptionID);
      }
    }).render('#paypal-button-container');
  });
</script>
